/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Lots_Col_Created_AtInputs */

const vi_pl_lots_col_created_at = /** @type {(inputs: Pl_Lots_Col_Created_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày tạo`)
};

/**

* @param {Pl_Lots_Col_Created_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_lots_col_created_at = /** @type {((inputs?: Pl_Lots_Col_Created_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Lots_Col_Created_AtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_lots_col_created_at(inputs)
});